<template>
  <div class="avatar-wrapper relative flex" :style="style" @click="$emit('click')">
    <img
      v-if="showEdit"
      class="absolute edit"
      src="@/assets/DefaultCloudzet/HomePage/edit.svg"
      alt="edit"
    />
    <img v-if="showUpload" class="absolute upload" src="@/assets/common/upload.svg" alt="Upload" />
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    src: String,
    width: {
      type: [Number, String],
      default: 60,
    },
    showEdit: Boolean,
    showUpload: Boolean,
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    style() {
      const width = typeof this.width === 'number' ? `${this.width}px` : this.width;
      return {
        width,
        height: width, // the same as width to make it rectangle
        borderRadius: this.rounded ? '8px' : 'none',
        backgroundImage: `url('${this.src}')`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-wrapper {
  background: no-repeat center;
  background-size: cover;
  box-shadow: 0px 0px 6px rgba(67, 78, 108, 0.5);
}
.edit {
  left: -7px;
  bottom: -7px;
}
.upload {
  width: 16px;
  left: 3px;
  bottom: 5px;
}
</style>
